<template>
	<div class="studylist">
		<topcon :maxtitle="'学习'" :mintitle="'资料'" :sign="'2'"></topcon>

		<div class="alllist">
			<div class="signle" v-for="(item,index) in list" :key="index"
			@click="todetail(item)">
				<!-- <div class="bit"></div> -->
				<div class="title overfh" :title='item.compilationTitle'>
					{{item.compilationTitle||''}}
				</div>
				<div class="date">{{item.publishTime.split(' ')[0] || ''}}</div>
			</div>
		</div>

	</div>

</template>

<script>

import topcon from "../com/topcon.vue";
export default {
  components: {
   	 topcon,
  },

  data: function() {
    return {
		list:[],

    };
  },

  mounted() {
		this.getStudyDatalist()
  },

  methods: {
		getStudyDatalist(){
			  this.$get(`web/info/studyData?studyType=1&pageSize=8&pageNo=1`).then(res=>{
				  if(res.success){
					  this.list = res.result.records;
				  }
			  })
		},

		todetail(item){
			this.$router.push({ path: '/learnmaterials?id='+item.id +'&type='+item.studyType});
		}

  },



};
</script>

<style scoped=" scoped" lang="scss">

.studylist{

	.alllist{
		margin-top:30px;
		min-height: 320px;
		.signle{
			display: flex;
			align-items: center;
			height: 40px;
			cursor: pointer;
			.title{
				flex: 1;
				font-size: 18px;
				font-weight: 400;
				color: #000000;
				margin-left: 10px;
				width: calc(100% - 130px);
			}
			.date{
				width: 120px;
				text-align: right;
				font-size: 18px;
				font-weight: 400;
				color: #666666;
			}
		}

		.signle:hover .title{
			color: #E61F26;
		}
		.signle:hover .date{
			color: #E61F26;
		}

	}





}

</style>
